export class Menu {

    constructor(domElm) {
        this.domElm = domElm;

        // Get menu elements
        this.burgerMenu = document.querySelector(".burger-menu-button");
        this.addListeners();
    }


    addListeners() {
        this.burgerMenu.addEventListener("click", () => {
            this.domElm.classList.toggle("show");
            this.burgerMenu.classList.toggle("show");
        })
    }
}
